import { Accessor, For, JSX, Signal, createMemo, createSignal } from 'solid-js'
import styles from './st-list.module.css'
import Flexbox from '../st-flexbox/st-flexbox';

interface ListProps<T extends readonly any[], U extends JSX.Element> {
    selected?: Signal<T[number] | undefined>
    items: T | undefined | null | false;
    fallback?: JSX.Element;
    children: (item: T[number], index: Accessor<number>) => U;
}

export default function List<T extends readonly any[], U extends JSX.Element>(props: ListProps<T, U>) {
    const [selected, setSelected] = props.selected ?? createSignal<T[number]>();

    const classes = createMemo(() => {
        const res = [styles.list];

        if (props.selected) {
            res.push(styles.interactive);
        }

        return res.join(' ');
    });

    function selectItem(it: T[number]) {
        if (props.selected) {
            setSelected(it);
        }
    }

    return <Flexbox as="ul" dir="vertical" class={classes()}>
        <For each={props.items}>{(it, idx) =>
            <Flexbox.Item as="li" onClick={() => selectItem(it)} class={it === selected() ? styles.active : undefined} role={props.selected ? 'button' : undefined} >{
                props.children(it, idx)
            }</Flexbox.Item>
        }</For>
    </Flexbox>
}

List.defaultProps = {
    items: [],
    children: (item: string, index: Accessor<number>) => ''
} as ListProps<string[], string>;
